import { create } from 'zustand';
import { profileImage } from '../data/main.data';

export const useZustand = create((set) => ({
    loginDescription: "",
    showDashboard: false,

    formName: "",
    formDescription: "",

    uploadStatus: "",

    artProjects: [],

    currentDisplayedProfile: profileImage.images[0],

    selectedUploadSection: "",

    
    setLoginDescription: (val) => set(() => ({ loginDescription: val })),
    setShowDashboard: (val) => set(() => ({ showDashboard: val })),

    setFormName: (val) => set(() => ({ formName: val })),
    setFormDescription: (val) => set(() => ({ formDescription: val })),

    setUploadStatus: (val) => set(() => ({ uploadStatus: val })),

    setArtProjects: (val) => set(() => ({ artProjects: val })),

    setCurrentDisplayedProfile: (val) => set(() => ({ currentDisplayedProfile: val })),

    setSelectedUploadSection: (val) => set(() => ({ selectedUploadSection: val })),

  }));